<template>
  <div>
    <div v-if="disabled && showList" :class="className">
      <div class="spaceLeft" v-for="(item, index) in showList" :key="index">
        <div class="ellipsis" style="flex: 1">
          {{ item && (item.fileNm || item.name) }}
        </div>
        <svg
          class="icon img-icon"
          aria-hidden="true"
          @click="downFile(item)"
          style="margin-left: 10px; color: #096dd9"
          title="下载"
        >
          <use xlink:href="#gold-icon-xiazai"></use>
        </svg>
        <!-- <a-icon type="cloud-download" @click="downFile(item)" style="margin-left:10px;color:#096dd9;" /> -->
      </div>
    </div>
    <div v-else :class="className">
      <a-upload
        v-show="hideButtonHasFiles ? fileList.length == 0 : true"
        :accept="accept"
        :multiple="limit>1"
        :file-list="fileList"
        :before-upload="beforeFileUpload"
        :remove="handleFileRemove"
        :customRequest="handleFileUpload"
        :disabled="disabled || fileList.length >= limit"
        :showUploadList="false"
      >
        <a-button class="spaceLeft" style="color: #1990ff">
          <svg class="icon img-icon" aria-hidden="true">
            <use xlink:href="#gold-icon-shangchuan"></use></svg
          >上传文件
        </a-button>
      </a-upload>
      <div class="file-list" v-if="fileListShow">
        <div
          class="spaceLeft file-list-item"
          v-for="item in fileList"
          :key="item.uid"
        >
          <div class="ellipsis" style="flex: 1">{{ item.name }}</div>
          <a-icon
            type="delete"
            @click="handleFileRemove(item)"
            style="margin-left: 10px; color: #ef763c"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileDeletAPI } from "@/api/file.js";
export default {
  name: "fileUpload",
  props: {
    accept: {
      type: String,
      required: false,
      default: function () {
        return ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF,.zip,.ZIP,.rar,.RAR,.doc,.docx,.xls,.xlsx,.ppt,.pptx";
      },
    },
    multiple: {
      type: Boolean,
      required: false,
      default: function () {
        return true;
      },
    },
    url: {
      type: String,
      required: false,
      default() {
        return "/gb-bigtree-file/fileUpload";
      },
    },
    // 可传入接口需要的参数
    paramObj: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    name: {
      type: String,
      required: true,
    },
    downUrl: {
      type: String,
      required: false,
      default: function () {
        return "";
      },
    },
    downName: {
      type: String,
      required: false,
      default: function () {
        return "空白模板.xlsx";
      },
    },
    limit: {
      type: [String, Number],
      required: false,
      default: function () {
        return 1;
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    showList: {
      //只读时的展示文件
      type: [Array],
      required: false,
      default: function () {
        return [];
      },
    },
    removeaction: {
      //删除时是否删除服务器文件
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    // 自定义class
    className: {
      type: [String],
      required: false,
    },
    // 已上传文件时，隐藏上传按钮
    hideButtonHasFiles: {
      type: [Boolean],
      required: false,
    },
    // 不展示文件列表
    fileListShow: {
      type: [Boolean],
      default: function () {
        return true;
      },
    },
    // 上传附件的时候是否自动调用save保存附件
    autoSave: {
      type: [Boolean],
      default: function () {
        return true;
      },
    },
  },
  data() {
    return {
      fileList: [],
      fileListCur: [],
      uploading: false,
      paramObjSelf: this.utils.deepClone(this.paramObj),
      fileIndex: 0,

    };
  },
  computed: {},
  watch: {
    showList: {
      immediate: true,
      handler: function (val) {
        if (val[0]) {
          this.fileList = val.map((item) => {
            return {
              ...item,
              name: item.name || item.fileNm,
              uid: item.uid || item.fileId,
            };
          });
          this.fileListCur = this.fileList
        } else {
          this.fileList = [];
          this.fileListCur= []
        }
      },
    },
  },
  methods: {
    beforeFileUpload(file, fileList) {
      console.log("%c Line:189 🍆 fileList", "color:#7f2b82", this.fileListCur);
      console.log("%c Line:189 🍆 fileList", "color:#7f2b82", fileList);
      console.log("%c Line:189 🍢 file", "color:#465975", file);
      if (file.name && file.name.indexOf(".") > -1) {
        let d_name = file.name.substring(file.name.lastIndexOf(".") + 1);
        if (this.accept.indexOf(d_name) > -1) {
          if(this.fileListCur&&this.fileListCur.length>0){
            this.fileListCur = [...this.fileListCur,file] ;
          }else{
            this.fileListCur = [file];
          }

          
          this.$emit("beforeFileUpload", this.fileList);
        } else {
          this.$message.error("请上传" + this.accept + "格式的文件");
          return false;
        }
      } else {
        this.$message.error("请上传" + this.accept + "格式的文件");
        return false;
      }
    },
    handleFileRemove(file) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
      this.fileListCur.splice(index, 1);
      this.$emit("remove", this.fileList);
       const params = {
          fileRte: file.fileRte,
          fileNm: file.name,
          fileExpdNm: file.fileExpdNm,
          fileSize: file.fileSize,
          tblBlId: file.tblBlId,
          fileId: file.fileId,
          fileTpCd: file.fileTpCd,
          fileSubTpCd: file.fileSubTpCd,
        };
      if (this.removeaction) {
       
        fileDeletAPI(params)
          .then((res) => {
            this.$emit("handleFileRemove", this.fileList);
            this.$emit("handleFileRemoveCopy", params);
            this.fileIndex = this.fileIndex - 1;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$emit("handleFileRemove", this.fileList);
        this.$emit("handleFileRemoveCopy", params);
        this.fileIndex = this.fileIndex - 1;
      }
    },
    handleFileUpload() {
      
      const formData = new FormData();
      this.fileListCur.forEach((file) => {
        formData.append(this.name, file);
        for (let key in this.paramObjSelf) {
          formData.append(key, this.paramObjSelf[key]);
        }
      });
      this.uploading = true;
      this.axios({
        url: this.url,
        data: formData,
        isTransform: false,
      })
        .then((res) => {})
        .catch((data) => {
          console.log("%c Line:246 🍭 data", "color:#fca650", data);
          console.log("%c Line:246 🍭 data", "color:#fca650",JSON.parse(data[0].savePath) );
                      console.log("%c Line:264 🍒 this.fileListCur", "color:#7f2b82", this.fileListCur);
                      console.log("%c Line:264 🍒 this.fileIndex", "color:#7f2b82", this.fileIndex);

          
          this.uploading = false;
          if (data&&data.length>0&&this.fileListCur[this.fileIndex]) {
            
            this.fileList.push({
              name: this.fileListCur[this.fileIndex].name,
              size: this.fileListCur[this.fileIndex].size,
              uid: this.fileListCur[this.fileIndex].uid,
              fileExpdNm: data[this.fileIndex].contentType,
              fileRte: JSON.parse(data[this.fileIndex].savePath).file,
              savePath: JSON.parse(data[this.fileIndex].savePath),
              tblBlId: this.paramObjSelf.tblBlId,
              fileTpCd: this.paramObjSelf.fileTpCd,
              fileSubTpCd: this.paramObjSelf.fileSubTpCd,
            });
            let fileObj = this.fileList[this.fileList.length - 1];
            this.$emit("uploadOk", this.fileList, this.paramObjSelf);
            // 用于多个文件上传，每次只往外传一个文件的值，便于外层组件多次调用上传保存接口
            this.$emit("uploadOkCopy", fileObj);
            // 上传压缩包返回压缩包里面的数据
            if(data&&data.length>0){
            this.$emit("uploadOkZip", JSON.parse(data[0].savePath).fileList);

            }

            this.fileIndex = this.fileIndex + 1;
            if(this.fileIndex > data.length ){
              this.fileIndex = 0;
            }
          }
        });
    },
    setParams(data) {
      this.paramObjSelf = data;
    },
    setFileList(item) {
      if (item) {
        this.fileList.push(item);
      } else {
        this.fileList = [];
      }
    },
    downFile(item) {
      const DOWNLOAD_PREFIX = "/gb-bigtree-file/download/fileDownload/install";
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        "_blank"
      );
    },
  },
  created() {
  },
};
</script>
<style scoped lang="less">
.ant-upload.ant-upload-disabled .ant-btn {
  cursor: no-drop;
  background: #f5f5f5;
}
.img-icon {
  font-size: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/file-upload/file-upload.vue